import React from "react";

import {
  calibrationAveragesFromPayload,
  formatCalibrationRate,
} from "./calibrationCheckAverages";

import "./CalibrationCheckSummary.css";

function MetricRow({ label, group, t }) {
  if (!group) return null;
  return (
    <div className="calibration-check-summary-cell">
      <span className="calibration-check-summary-cell-label">{label}</span>
      <span className="calibration-check-summary-cell-value">
        {formatCalibrationRate(group.hectaresPerHour, t("ha/h"), 2)}
      </span>
      <span className="calibration-check-summary-cell-value">
        {formatCalibrationRate(group.fertilizerKgHa, t("kg/ha"))}
      </span>
      <span className="calibration-check-summary-cell-value">
        {formatCalibrationRate(group.seedThousand, t("mil/ha"))}
      </span>
      <span className="calibration-check-summary-cell-value">
        {formatCalibrationRate(group.inoculantLHa, t("L/ha"))}
      </span>
    </div>
  );
}

export default function FieldAppCalibrationCheckSummary({
  payload,
  t,
  demo = false,
  title,
  note,
}) {
  const summary = calibrationAveragesFromPayload(payload);
  if (!summary) return null;

  const last3Label =
    summary.last3Count > 1
      ? t("Média últimas {{count}} abastecidas", { count: summary.last3Count })
      : t("Última abastecida");

  return (
    <div
      className={`calibration-check-summary${
        demo ? " calibration-check-summary--demo" : ""
      }`}
    >
      <div className="calibration-check-summary-header">
        <h4 className="calibration-check-summary-title">
          {title || t("Médias do check de calibragem")}
        </h4>
        {note ? <p className="calibration-check-summary-note">{note}</p> : null}
      </div>
      <div className="calibration-check-summary-grid">
        <div className="calibration-check-summary-row-labels">
          <span></span>
          <span>{t("ha/h")}</span>
          <span>{t("Adubo")}</span>
          <span>{t("Semente")}</span>
          <span>{t("Inoculante")}</span>
        </div>
        {summary.hasCurrent ? (
          <MetricRow label={t("Esta abastecida")} group={summary.current} t={t} />
        ) : null}
        {summary.hasLast3 ? (
          <MetricRow label={last3Label} group={summary.last3} t={t} />
        ) : null}
        {summary.hasTotal && summary.totalCount >= 2 ? (
          <MetricRow label={t("Média total")} group={summary.total} t={t} />
        ) : null}
      </div>
    </div>
  );
}
